import React from 'react';
import DataComponent from './DataComponent';
import './PosterPage.css';
import { posters } from '../data/posters';
import { Link, useParams } from 'react-router-dom';

const PosterPage: React.FC = () => {
    const { id } = useParams();
    const poster = posters.find(p => p.id === id);

    if (!poster) {
        return <div>Poster not found</div>;
    }

    return (
        <div className="poster-page">
            <div className="poster-header">
                <h1>{poster.title}</h1>
                <p className="poster-description">{poster.description}</p>
            </div>
            <div className="poster-content">
                {poster.dataItems.map((item, index) => (
                    <Link
                        key={item.id}
                        to={`/poster/${poster.id}/${item.id}`}
                        className="poster-link"
                    >
                        <div
                            key={item.id}
                            id={item.id}
                            className="data-item-container"
                        >
                            <DataComponent
                                id={item.id}
                                title={item.title}
                                data={item.data}
                                description={item.description}
                            />
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default PosterPage; 